import jssVariables from "../../jss_setup";

export const searchStripActivities = {
  searchStripContent: {
    background: "#EBF2F2",
    smallscreen: {
      background: "#EBF2F2",
    },
  },
  destinationText: {
    borderRadius: 0,
  },
  datesText: {
    borderRadius: 0,
  },
  paxText: {
    borderRadius: 0,
  },
  btns: {
    background: "#EBF2F2",
    paddingTop: jssVariables.half_gap,
  },
};

export const activityStyles = {
  category: {
    background: "#9D9D9D",
  },
  viewBtnStyles: {
    ButtonDefault: {
      background: jssVariables.colors.secondary_color,
      borderColor: jssVariables.colors.secondary_color,
      "&:hover": {
        color: jssVariables.colors.secondary_color,
        background: "white",
      },
    },
  },
  priceTxt: {
    fontWeight: 600,
  },
  priceValue: {
    fontWeight: 700,
    fontSize: "large",
  },
};

export const actRating = {
  iconFilled: {
    fontSize: "medium",
    color: "black",
  },
  iconEmpty: {
    fontSize: "medium",
    color: "black",
  },
};

export const ActPriceSearchForm = {
  underlay: {
    backdropFilter: "blur(15px)",
  },
  ActPriceSearchForm: {
    justifyContent: "center",
    justifyItems: "center",
  },
  priceContr: {
    fontWeight: 600,
  },
  priceComponent: {
    fontSize: "x-large",
    fontWeight: 800,
    color: jssVariables.colors.base_color,
  },
  inputGroup: {
    gridTemplateColumns: "repeat(2, max-content)",
    gridGap: jssVariables.half_gap,
    alignItems: "center",
    padding: [0, jssVariables.half_gap],
  },
  label: {
    fontWeight: 600,
    fontSize: "small",
  },
  datepicker: {
    width: "8rem",
    borderRadius: 0,
    borderColor: "#D2D2D2",
  },
};

export const ActSchedulesModal = {
  bottomContainer: {
    color: jssVariables.colors.base_color,
  },
  priceComponentTotal: {
    priceComponent: {
      color: jssVariables.colors.base_color,
      fontSize: "x-large",
      fontWeight: 800,
    },
  },
};

export const ActPreBook = {
  img: {
    width: "70%",
  },
  content: {
    "& img": {
      placeSelf: "baseline",
      borderRadius: "0.125rem",
    },
  },
  priceComponent: {
    priceComponent: {
      fontWeight: 800,
      color: jssVariables.colors.base_color,
      fontSize: "x-large",
    },
  },
};
